import * as React from 'react';
import './ProjectInvested.css';
import '../Project.css';
import ProjectInterestedCardContainer from '../project-interested/ProjectInterestedCard.container';
import Person from 'src/entities/Person';
import ProjectActionToolbarContainer from 'src/modules/project/partials/action-toolbar/ProjectActionToolbar.container';
import Project from 'src/entities/Project';

interface Props {
  projectInvested: Person[];
  project: Project;
  invest: boolean;
  closedProject: boolean;
}

class ProjectInvestedComponent extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    return (
      <div className="col-sm-9">

        <div className="padding-left-30">

          <div className="gap-50"/>

          <h3>
            Inversores
          </h3>
          <div className="gap-20"/>
          <div className="gap-30"/>
          <div className="row padding-l-r-30">
            {this.props.projectInvested.map((interestedUser, key) => {
              return (
                <ProjectInterestedCardContainer
                  key={key}
                  interestedUser={interestedUser}
                />
              );
            })}
          </div>
          <div className="gap-50"/>
          <ProjectActionToolbarContainer
            project={this.props.project}
            invest={this.props.invest}
            closedProject={this.props.closedProject}
          />
          <div className="gap-50"/>

        </div>

      </div>
    );
  }
}

export default ProjectInvestedComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-invested/ProjectInvested.component.tsx